import LoginPage from "erp/LoginPage";

// @material-ui/icons
import Fingerprint from "@material-ui/icons/Fingerprint";

const defaultRoutes = [
    //{
    //    path: "/register",
    //    name: "Register Page",
    //    short: "Register",
    //    mini: "RP",
    //    icon: PersonAdd,
    //    component: RegisterPage
    //},
    
    {
        path: "/login",
        name: "Login Page",
        short: "Login",
        mini: "LP",
        icon: Fingerprint,
        component: LoginPage
    }
    //{
    //    path: "/pages/pricing-page",
    //    name: "Pricing Page",
    //    short: "Pricing",
    //    mini: "PP",
    //    icon: MonetizationOn,
    //    component: PricingPage
    //},
    //{
    //    path: "/pages/lock-screen-page",
    //    name: "Lock Screen Page",
    //    short: "Lock",
    //    mini: "LSP",
    //    icon: LockOpen,
    //    component: LockScreenPage
    //},
    //{
    //    redirect: true,
    //    path: "/pages",
    //    pathTo: "/pages/register-page",
    //    name: "Register Page"
    //}
];

export default defaultRoutes;



// WEBPACK FOOTER //
// ./src/erp/routes/DefaultRoutes.js